import { render, staticRenderFns } from "./argroup.vue?vue&type=template&id=7c89e2a8"
import script from "./argroup.vue?vue&type=script&lang=js"
export * from "./argroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports